import Model from './Model'

export default class Transaction extends Model {
  resource() {
    return 'transactions'
  }
}
